import React from "react";

type Props = {
	indeterminate?: boolean;
};

const Checkbox: React.ForwardRefRenderFunction<HTMLInputElement, Props> = (
	{ indeterminate = false, ...rest },
	ref
) => {
	const defaultRef = React.useRef<HTMLInputElement>();
	const resolvedRef = (ref ||
		defaultRef) as React.MutableRefObject<HTMLInputElement>;

	React.useEffect(() => {
		if (resolvedRef.current) {
			resolvedRef.current.indeterminate = indeterminate;
		}
	}, [indeterminate]);

	return (
		<>
			<input type="checkbox" ref={resolvedRef} {...rest} />
		</>
	);
};

export default React.forwardRef(Checkbox);
